import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { userRole_globalAdmin, userRole_regionalAdmin } from '../appConstant';
import { AppGlobals } from '../Services/app.global';

@Injectable()
export class ManageLocationGuard implements CanActivate {
  constructor(
    private _appGlobals: AppGlobals,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this._appGlobals.acType.map(acType => {
        const allowableAccountTypes: Array<String> = [
          userRole_globalAdmin,
          userRole_regionalAdmin,
        ];
        return allowableAccountTypes.some(allowableAccountType => allowableAccountType === acType);
      });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/guards/manage-location.guard.ts